export type PlatformTemplate = {
  platform: 'instagram' | 'x' | 'tiktok' | 'youtube';
  captionTemplate: string; // may contain variables like {{product}}
  recommendedImage?: string;
};

export type Template = {
  id: string;
  title: string;
  description: string;
  category: 'weekly' | 'campaign' | 'evergreen' | 'holiday';
  platforms: PlatformTemplate[];
  estimatedDays?: number; // length of campaign
};

export const sampleTemplates: Template[] = [
  {
    id: 'tpl-weekly-1',
    title: 'Weekly Tips Series',
    description: 'A 4-post weekly tips series that positions you as an expert.',
    category: 'weekly',
    estimatedDays: 7,
    platforms: [
      { platform: 'instagram', captionTemplate: 'Tip of the week: {{tip}}\nSave this for later! #{{hashtag}}' },
      { platform: 'x', captionTemplate: 'Tip: {{tip}} — RT if useful #{{hashtag}}' }
    ]
  },
  {
    id: 'tpl-launch-1',
    title: 'Product Launch Countdown',
    description: 'Campaign spread across 7 days leading up to launch.',
    category: 'campaign',
    estimatedDays: 7,
    platforms: [
      { platform: 'instagram', captionTemplate: 'Day {{day}} to launch: {{teaser}}. Pre-order at {{link}} #launch' },
      { platform: 'x', captionTemplate: 'T-minus {{day}} days — {{teaser}}. {{link}}' }
    ]
  },
  {
    id: 'tpl-evergreen-1',
    title: 'Evergreen How-To',
    description: 'Reusable how-to post you can schedule anytime.',
    category: 'evergreen',
    estimatedDays: 1,
    platforms: [
      { platform: 'instagram', captionTemplate: 'How to {{topic}} — step by step. Save for later! #howto #{{hashtag}}' },
      { platform: 'youtube', captionTemplate: 'In this video: {{topic}}. Link in bio.' }
    ]
  },
  {
    id: 'tpl-holiday-1',
    title: 'Holiday Promo',
    description: 'Short promo template for holidays and events.',
    category: 'holiday',
    estimatedDays: 3,
    platforms: [
      { platform: 'instagram', captionTemplate: 'Holiday sale! Use code {{promo}} for {{discount}} off. Shop: {{link}}' }
    ]
  }
];

export function getTemplates() {
  return sampleTemplates;
}
